import React, { useContext, useState, useEffect, useRef } from "react";
import { forEach, keys } from "lodash";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { AppContext, UPDATE_STATE } from "../../AppContext";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ProjectSubmissionDetails,
  getProjectDetailsById,
  UserTracker,
  loadOptions,
  getProjectCategories,
  addProjectCategory,
  EnrollProjectByParticipnatId,
  GetSubmittedParticipantsDetails,
  getUnavailableParticipants
} from "../services/apiFunctions";
import { Submit } from "../UserTrackingConstants";
import { AsyncPaginate } from "react-select-async-paginate";
import PopupModal from "../../PopUp/PopupModal";
import { DELETETOPIC, PARTICIPANTSUBMIT } from "../../PopUp/ModalConstants";
import ProjectCard from "../../ProjectCards";
const ParticipantRegisterPage = () => {
  const [loader, setLoader] = useState(true);
  const [participantId, setparticipantId] = useState();
  const [projectId, setprojectid] = useState();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [TeammembersnameErrMsg, setTeammembersnameErrMsg] = useState("");
  const [ProjectCategoryErrMsg, setProjectCategoryErrMsg] = useState("");
  const [TeammembersnameError, setTeammembersnameError] = useState(false);
  const [topicDetailsData, setTopicDetailsData] = useState({});
  const [teamName, setTeamName] = useState();
  const [projectTitle, setProjectTitle] = useState();
  const [projectDesc, setProjectDesc] = useState();
  const [data, dispatch] = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(0);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [addedCategories, setAddedCategories] = useState([])
  const [selectedTeamMembersData, setSelectedTeamMembersData] = useState([]);
  const [removedFields, setRemovedFields] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(null);
  const [form, setForm] = useState({});
  const [modalShow_routing, setmodalShow_routing] = useState(false);
  const [CurrentTopic, SetCurrentTopic] = useState();
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [unavailableIds, setUnavailableIds] = useState([]);
  const [idsLoaded, setIdsLoaded] = useState(false);

  useEffect(() => {
    if (addedCategories.length != 0) {
      setProjectCategoryErrMsg(null)
    }
  }, [addedCategories])

  const fetchCategories = async () => {
    try {
      const response = await getProjectCategories();
      if (response?.status === 200 && Array.isArray(response.data)) {
        const formattedOptions = response.data.map((item) => ({
          value: item.id,
          label: item.category,
        }));
        setCategoryOptions(formattedOptions);
      } else {
        toast.error("Failed to fetch categories");
      }
    } catch (error) {
      console.error("Error fetching categories", error);
      toast.error("Error fetching categories");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);


  const fetchTopicDetails = async (projectId) => {
    setLoader(true);
    try {
      setprojectid(window.location.pathname.split("/")[2]);

      if (sessionStorage.getItem("userid") != null) {
        setparticipantId(sessionStorage.getItem("userid"));
      }
      sessionStorage.setItem("projectId", projectId);
      dispatch({
        type: UPDATE_STATE,
        payload: {
          projectId: sessionStorage.getItem("projectId"),
        },
      });
      const response = await getProjectDetailsById(
        projectId,
        participantId,
        JSON.parse(data.CurrentEvent).id
      );

      if (response !== undefined) {
        if (keys(response?.data)?.length > 0) {
          console.log("getProjectDetailsById", response?.data);
          setTopicDetailsData(response?.data);
        }
      } else {
        console.log(response);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const fetchUnavailableIds = async (projectId) => {
    try {
      const response = await getUnavailableParticipants(projectId)
      if (response?.status === 200) {
        setUnavailableIds(Array.isArray(response.data) ? response.data : []);
        }

    } catch (err) {
    setUnavailableIds([]);
    } finally {
      setIdsLoaded(true);
    }
  };

  useEffect(() => {
    GetProjectDetailsById(window.location.pathname.split("/")[2]);
    fetchTopicDetails(window.location.pathname.split("/")[2]);
    fetchUnavailableIds(window.location.pathname.split("/")[2])
    console.log(
      "window.location.pathname.split",
      window.location.pathname.split("/")[3]
    );
  }, []);

  useEffect(() => {
    console.log("added categories: ", addedCategories)
  }, [addedCategories])
  const GetProjectDetailsById = async (id) => {
    setLoader(true);
    try {
      if (id != null) {
        const response = await getProjectDetailsById(
          id,
          null,
          JSON.parse(data.CurrentEvent).id
        );
        if (response !== undefined) {
          SetCurrentTopic(response?.data);
          console.log("getProjectDetailsById", response);
          setLoader(false);
        } else {
          console.log(response);
          setLoader(false);
          //setVisiblity(false);
        }
      }
    } catch (error) {
      toast.error("Something Went Wrong");
      setLoader(false);
      console.log(error);
    }
  };

  function validateTeammember(updatedTeamMembersList) {
    if (updatedTeamMembersList.length === 0) {
      setTeammembersnameErrMsg("Please choose alteast one team member name.");
      setTeammembersnameError(true);
      return;
    } else {
      setTeammembersnameErrMsg(null);
      setTeammembersnameError(false);
    }
  }
  function validateCategories(addedCategories) {
    if (addedCategories.length === 0) {
      setProjectCategoryErrMsg("Please choose alteast one Category name.");
      return;
    } else {
      setProjectCategoryErrMsg(null);
    }
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    validateTeammember(teamMembersData);
    validateCategories(addedCategories);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      const payload = {
        ProjectId: projectId,
        ProjectName: projectTitle,
        ProjectDescription: projectDesc,
        AddProjectCategories: addedCategories.map((cat) => ({
          CategoryId: cat.value,
          EmpId: participantId,
        })),
        status: "Registered",
        ParticipantId: participantId,
        Teamname: event.target.teamName.value,
        AddTeamMembers: teamMembersData,
        RemovedTeamMembers: removedFields,
        EventId: JSON.parse(data.CurrentEvent).id,
      };
      console.log("payload", payload);
      try {
        setLoader(true);
        const response = await ProjectSubmissionDetails(payload);
        if (response.status == 200) {
          toast.success("Registered Sucessfully");

          setLoader(false);
          const UserTrackerPyload = {
            data: JSON.stringify(payload),
            Host: window.location.href,
            Type: Submit,
            CreatedById: data.userempid,
          };
          const UserTrackerresponse = await UserTracker(UserTrackerPyload);
          console.log("UserTrackerresponse", UserTrackerresponse);
          setmodalShow_routing(true);
        } else {
          toast.error(response.data.message);
          console.log("response", response);
        }
      } catch (error) {
        setLoader(false);
        console.log(error);
        toast.error("Something went wrong");
      }
    } else {
      if (form.teamName.checkValidity() == false) {
        toast.warning("Form Invalid");
      }
    }
  };

  const defaultAdditional = {
    page: 1,
  };

  const loadPageOptions = async (q, prevOptions, { page }) => {
    let page1 = currentPage + 1;
    setCurrentPage(page1);
    console.log("FeatchJuriesList called");
    if (q == "") {
      const response = await loadOptions(q, page1, 1000);
      let options = [];

      if (response !== undefined && response.data.length > 0) {
        response.data.forEach((element) => {
      const obj = {};
          obj.label = element.cn;
          obj.value = {
            email: element.mails,
            name: element.cn,
            empId: element.employeenumber,
          };
          options.push(obj);
        });
      }

      const hasMore = options.length >= 50 ? true : false;
      return {
        options,
        hasMore,
      };
    } else {
      const response = await loadOptions(q, 1, 1000);

      let options = [];
      if (response !== undefined && response.data.length > 0) {
        response.data.forEach((element) => {
          const obj = {};
          obj.label = element.cn;
          obj.value = {
            email: element.mails,
            name: element.cn,
            empId: element.employeenumber,

          };
          options.push(obj);
        });
      }

      const hasMore = options.length >= 50 ? true : false;
      return {
        options,
        hasMore,
      };
    }
  };

  const handleCreateCategory = async (inputValue) => {
    const createdBy = sessionStorage.getItem("userid") || "anonymous";

    try {
      const response = await addProjectCategory(inputValue, createdBy);
      console.log("add category response: ", response)
      if (response?.status === 200) {
        const newCategory = response.data
        const newOption = { value: newCategory.id, label: newCategory.category };

        setCategoryOptions((prev) => [...prev, newOption]);
        setAddedCategories((prev) => [...prev, newOption]);
        console.log("added categories: ", addedCategories)

        toast.success("New category added successfully");
      } else {
        toast.error("Failed to add category");
      }
    } catch (error) {
      console.error("Create category error", error);
      toast.error(`Failed to create category: ${error.message}`);
    }
  };


  const removeTeamMember = async (index) => {
    if (index === null) {
      return;
    }

    let data = [...teamMembersData];

    if (data[index].id) {
      setRemovedFields([...removedFields, data[index]]);
    }

    setSelectedTeamMembersData(
      selectedTeamMembersData.filter((obj, ind) => ind !== index)
    );

    data.splice(index, 1);
    setTeamMembersData(data);
    validateTeammember(data);
    setRemoveIndex(null);
    toast.info("Removed the Team Member");
  };

  function formatDateTime(date) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);

    const [month, day, year] = formattedDate.split(" ");

    return `${day} ${month} ${year}`;
  }
  const addOrRemoveTeamMember = (selectedTeamMembers, optionSelected) => {
    let updatedTeamMembersList = [];
    if (optionSelected.action === "clear") {
      let removedTeamMembers = [...removedFields];
      optionSelected.removedValues.forEach((removedValue) => {
        if (removedValue.value.id) {
          removedTeamMembers.push(removedValue.value);
        }
      });
      setSelectedTeamMembersData([]);
      setTeamMembersData([]);
      setRemoveIndex(null);
    } else if (
      optionSelected.action === "remove-value" ||
      optionSelected.action === "pop-value"
    ) {
      let index = teamMembersData.findIndex(
        (teamMember) =>
          teamMember.empId === optionSelected.removedValue.value.empId
      );
      SetModalValues(index);
    } else {
      const newTeamMemberIndex =
        selectedTeamMembers.length > 0 ? selectedTeamMembers.length - 1 : 0;
      const teamMemberExists = teamMembersData.some(
        (obj) =>
          obj?.empId === selectedTeamMembers[newTeamMemberIndex].value?.empId
      );

      if (!teamMemberExists) {
          const selectedEmpId = selectedTeamMembers[newTeamMemberIndex].value.empId;
        const isTeamMemberAlreadyRegistered = unavailableIds.includes(selectedEmpId);

        if (isTeamMemberAlreadyRegistered) {
          toast.error("Team member already present in another team");
          return;
        }

        const checkTeamMemberInRemovedFields = removedFields.some(
          (obj) =>
            obj.empId === selectedTeamMembers[newTeamMemberIndex].value.empId
        );
        const teamMemberObj = {
          name: selectedTeamMembers[newTeamMemberIndex].value.name,
          email: selectedTeamMembers[newTeamMemberIndex].value.email,
          empId: selectedTeamMembers[newTeamMemberIndex].value.empId,
        };
        if (checkTeamMemberInRemovedFields) {
          const tempTeamMember = removedFields.find(
            (obj) =>
              obj.empId === selectedTeamMembers[newTeamMemberIndex].value.empId
          );
          if (tempTeamMember?.id) {
            Object.assign(teamMemberObj, {
              id: tempTeamMember?.id,
            });
          }

          setRemovedFields(
            removedFields.filter(
              (obj) =>
                obj.empId !==
                selectedTeamMembers[newTeamMemberIndex].value.empId
            )
          );
        }
        updatedTeamMembersList = [...teamMembersData, teamMemberObj];
        setTeamMembersData(updatedTeamMembersList);
        setSelectedTeamMembersData(selectedTeamMembers);
        toast.info("Team Member added successfully");
        console.log("Team Member,", updatedTeamMembersList);
      } else {
        toast.info("Team Member already selected");
      }
    }
    validateTeammember(updatedTeamMembersList);
  };

  const SetModalValues = (index) => {
    setModalShow(true);
    setRemoveIndex(index);
  };

  const handleCategoryChange = (newValue) => {
    setAddedCategories(newValue || []);
  };

  return (
    <div className="profile-submit profile-height">
      {loader && (
        <div id="backdrop-submit">
          <div className="text-center loading">
            <div
              className="spinner-border custom-spinner spin-signup"
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      <div className="profile-header">
        <div className="profile-header-cover" />
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="card border-0 mt-2">
              <div className="card-body">
                <div className="row">
                  <Col
                    xs={{ span: 12, order: 2 }}
                    md={{ span: 9, order: 1 }}
                    lg={{ span: 9, order: 1 }}
                  >
                    <p className="participant-heading">
                      Project Registration Form
                    </p>
                    <div>
                      <p className="mb-0 submit_heading2 mb-0 pb-0">
                        {" "}
                        Topic name : {topicDetailsData.name}
                      </p>
                      <p className="mb-0 ">
                        Ends On :{" "}
                        {formatDateTime(topicDetailsData.submissionEnddate)}
                      </p>
                    </div>
                    <div className="row">
                      <Col>
                        {/* className="col-md-9 col-lg-9 col-sm-12 " */}

                        <hr className="verticleline"></hr>
                        <Form
                          noValidate
                          validated={validated}
                          onSubmit={handleSubmit}
                          id="participantRegister"
                          className="form submit-form"
                        >
                          <p className="sub-heading"> Project Details </p>
                          <div className="row">
                            <div className="col-md-6 col-lg-6 col-12 col-sm-6">
                              <Form.Label className="participant-label">
                                <h6 className="mb-0">
                                  Project Title
                                  <span className="text-danger">*</span>
                                </h6>
                              </Form.Label>
                              <br />
                              <small className="pb-2 participant-sublabel">
                                What are you calling it?
                              </small>{" "}
                              <span className="float-end">
                                {projectTitle == undefined ? 0 : projectTitle?.length}
                                /50
                              </span>
                              <Form.Control
                                type="text"
                                id="projectTitle"
                                placeholder="Project Title"
                                className="form-control participant-input"
                                maxlength={50}
                                required
                                value={projectTitle}
                                onChange={(event) => {
                                  setProjectTitle(event.target.value);
                                  form.projectTitle = event.target.value;
                                }}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="formFeedback participant-input"
                              >
                                Please enter the Project Title
                              </Form.Control.Feedback>
                            </div>
                            <div className="col-md-6 col-lg-6 col-12 col-sm-6">
                              <Form.Label className="participant-label">
                                <h6 className="mb-0">
                                  Category <span className="text-danger">*</span>
                                </h6>
                              </Form.Label>
                              <br/>
                              <small className="pb-2 participant-sublabel">Select or create categories</small>
                              <CreatableSelect
                                isMulti
                                isClearable
                                options={categoryOptions}
                                value={addedCategories}
                                onChange={(selected) => setAddedCategories(selected || [])}
                                onCreateOption={handleCreateCategory}
                                className="react-select-container mt-1"
                                classNamePrefix="react-select"
                              />

                              <p className="fieldError participant-input">
                                {ProjectCategoryErrMsg}
                              </p>

                              <Form.Control.Feedback type="invalid">
                                Please select at least one category
                              </Form.Control.Feedback>

                              
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 col-lg-12 col-12 col-sm-12">
                              <Form.Label className="participant-label">
                                <h6 className="mb-0">
                                  Project Description
                                  <span className="text-danger">*</span>
                                </h6>
                              </Form.Label>
                              <br />
                              <small className="pb-2 participant-sublabel">
                                Write a short, sharp point on description of
                                your project
                              </small>{" "}
                              <span className="float-end">
                                {projectDesc === undefined
                                  ? 0
                                  : projectDesc?.length}
                                /200
                              </span>
                              <textarea
                                rows={3}
                                cols={200}
                                placeholder="Add project description"
                                type="textArea"
                                id="projectDesc"
                                className="form-control participant-input"
                                maxLength={200}
                                onChange={(event) => {
                                  setProjectDesc(event.target.value);
                                  form.description = event.target.value;
                                }}
                                value={projectDesc}
                                required
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="formFeedback"
                              >
                                Please enter the description.
                              </Form.Control.Feedback>
                            </div>
                          </div>
                          <p className="sub-heading mt-3"> Team Details </p>
                          <div className="row">
                            <div className="col-md-6 col-lg-6 col-12 col-sm-6">
                              <Form.Label className="participant-label">
                                <h6 className="mb-0">
                                  Team Name
                                  <span className="text-danger">*</span>
                                </h6>
                              </Form.Label>
                              <br />
                              <small className="pb-2 participant-sublabel">
                                What are you calling it?
                              </small>{" "}
                              <span className="float-end">
                                {teamName == undefined ? 0 : teamName?.length}
                                /50
                              </span>
                              <Form.Control
                                type="text"
                                id="teamName"
                                placeholder="Team Name"
                                className="form-control participant-input"
                                maxlength={50}
                                required
                                value={teamName}
                                onChange={(event) => {
                                  setTeamName(event.target.value);
                                  form.teamname = event.target.value;
                                }}
                              />
                              <Form.Control.Feedback
                                type="invalid"
                                className="formFeedback participant-input"
                              >
                                Please enter the Team Name
                              </Form.Control.Feedback>
                            </div>
                            <div className="col-md-6 col-lg-6 col-12 col-sm-6">
                              <Form.Label className="labparticipant-labelel">
                                <h6 className="mb-0">
                                  Team Members Name
                                  <span className="text-danger">*</span>
                                </h6>
                              </Form.Label>
                              <br />
                              <small className="pb-2 participant-sublabel">
                                Write your team members
                              </small>{" "}
                              <AsyncPaginate
                                debounceTimeout={300}
                                placeholder="Select a Team member name"
                                value={selectedTeamMembersData}
                                loadOptions={loadPageOptions}
                                additional={defaultAdditional}
                                onChange={addOrRemoveTeamMember}
                                isDisabled={!idsLoaded}
                                isMulti
                              />
                              <p className="fieldError participant-input">
                                {TeammembersnameErrMsg}
                              </p>
                              <PopupModal
                                content={
                                  "Team Member - " +
                                  teamMembersData[removeIndex]?.name
                                }
                                title={"Remove Team Member?"}
                                type={DELETETOPIC}
                                show={modalShow}
                                ok={() => removeTeamMember(removeIndex)}
                                onHide={() => setModalShow(false)}
                              />
                            </div>
                          </div>
                          <div className="col-md-12 col-12 text-end mt-3">
                            <Button
                              style={{ marginRight: "10px" }}
                              // className="hpe-secondary-btn"
                              className="hpe-btn primary-outline-btn-hpe"
                              onClick={() => navigate(-1)}
                            >
                              {/* onClick={} */}
                              <FontAwesomeIcon icon={faXmark} /> Cancel
                            </Button>

                            <Button
                              type="submit"
                              className="hpe-btn primary-btn-hpe ml-2"
                            >
                              <FontAwesomeIcon icon={faPaperPlane} />{" "}
                              Register
                            </Button>
                          </div>
                        </Form>
                      </Col>
                    </div>
                  </Col>
                  <Col
                    xs={{ span: 12, order: 1 }}
                    md={{ span: 3, order: 2 }}
                    lg={{ span: 3, order: 3 }}
                  >
                    <div className="row">
                      <p className="submit_heading2 topic-padding">
                        {" "}
                        Current Topic{" "}
                      </p>
                      <Col>
                        {!loader && (
                          <div>
                            <Row>
                              <Col lg={1} className=" xsHidden">
                                <div className="h-100  ">
                                  <div className="vr h-100 xsHidden verticleline"></div>
                                </div>
                              </Col>
                              <Col lg={11}>
                                {CurrentTopic != undefined && (
                                  <ProjectCard
                                    hackthonProject={CurrentTopic}
                                  ></ProjectCard>
                                )}
                              </Col>
                            </Row>
                          </div>
                        )}
                      </Col>
                    </div>
                  </Col>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupModal
        title={"Confirmation"}
        type={PARTICIPANTSUBMIT}
        show={modalShow_routing}
        ok={(path) => navigate(path)}
        onHide={() => setmodalShow_routing(false)}
      />
    </div>
  );
};

export default ParticipantRegisterPage;
